
export const stateCoordinates = {
  "Andaman and Nicobar Island": [92.6586, 11.7401],
  "Andhra Pradesh": [79.400, 14.9129],
  "Arunanchal Pradesh": [94.7278, 28.217999],
  "Assam": [92.537842, 26.244156],
  "Bihar": [85.3131, 25.0961],
  "Chhattisgarh": [81.828232, 21.295132],
  "Puducherry": [79.8083, 11.9416],
  "Punjab": [75.5794, 29.7333],
  "Rajasthan": [73.432617, 27.391277],
  "Sikkim": [88.5122, 27.5330],
  "Tamil Nadu": [78.656891, 11.127123],
  "Chandigarh": [76.7794, 29.7333],
  "Telangana": [79.100815, 17.674857],
  "Tripura": [91.746826, 23.745127],
  "Uttar Pradesh": [79.826660, 28.207609],
  "Uttarakhand": [79.0193, 30.0668],
  "West Bengal": [87.747803, 21.97],
  "Odisha": [84.803467, 20],
  "Dadara and Nagar Havelli": [73.0169, 20.2700],
  "Daman and Diu": [72.8328, 20.3974],
  "Goa": [74.1240, 15.2993],
  "Gujarat": [72.136230, 22.309425],
  "Haryana": [76.431885, 28.238478],
  "Himachal Pradesh": [77.571167, 32.084206],
  "Jammu and Kashmir": [76.5762, 33.7782],
  "Jharkhand": [85.2799, 23.6102],
  "Karnataka": [75.713890, 15.317277],
  "Kerala": [76.271080, 10.850516],
  "Lakshadweep": [72.6417, 10.5667],
  "Madhya Pradesh": [77.947998, 22.473324],
  "Maharashtra": [75.300293, 19.663280],
  "Manipur": [93.9063, 24.6637],
  "Meghalaya": [91.3662, 25.4670],
  "Mizoram": [92.9376, 23.1645],
  "Nagaland": [94.5624, 26.1584],
  "Delhi": [77.1025, 28.7041],
};

export const StateEnumCoordinates = {
  "INDIAN_STATE_ANDAMAN_AND_NICOBAR_ISLAND": [
      92.6586,
      11.7401
  ],
  "INDIAN_STATE_ANDHRA_PRADESH": [
      79.4,
      14.9129
  ],
  "INDIAN_STATE_ARUNACHAL_PRADESH": [
      94.7278,
      28.217999
  ],
  "INDIAN_STATE_ASSAM": [
      92.537842,
      26.244156
  ],
  "INDIAN_STATE_BIHAR": [
      85.3131,
      25.0961
  ],
  "INDIAN_STATE_CHHATTISGARH": [
      81.828232,
      21.295132
  ],
  "INDIAN_STATE_PUDUCHERRY": [
      79.8083,
      11.9416
  ],
  "INDIAN_STATE_PUNJAB": [
      75.5794,
      29.7333
  ],
  "INDIAN_STATE_RAJASTHAN": [
      73.432617,
      27.391277
  ],
  "INDIAN_STATE_SIKKIM": [
      88.5122,
      27.533
  ],
  "INDIAN_STATE_TAMIL_NADU": [
      78.656891,
      11.127123
  ],
  "INDIAN_STATE_CHANDIGARH": [
      76.7794,
      29.7333
  ],
  "INDIAN_STATE_TELANGANA": [
      79.100815,
      17.674857
  ],
  "INDIAN_STATE_TRIPURA": [
      91.746826,
      23.745127
  ],
  "INDIAN_STATE_UTTAR_PRADESH": [
      79.82666,
      28.207609
  ],
  "INDIAN_STATE_UTTARAKHAND": [
      79.0193,
      30.0668
  ],
  "INDIAN_STATE_WEST_BENGAL": [
      87.747803,
      21.97
  ],
  "INDIAN_STATE_ODISHA": [
      84.803467,
      20
  ],
  "INDIAN_STATE_DADARA_AND_NAGAR_HAVELLI": [
      73.0169,
      20.27
  ],
  "INDIAN_STATE_DAMAN_AND_DIU": [
      72.8328,
      20.3974
  ],
  "INDIAN_STATE_GOA": [
      74.124,
      15.2993
  ],
  "INDIAN_STATE_GUJARAT": [
      72.13623,
      22.309425
  ],
  "INDIAN_STATE_HARYANA": [
      76.431885,
      28.238478
  ],
  "INDIAN_STATE_HIMACHAL_PRADESH": [
      77.571167,
      32.084206
  ],
  "INDIAN_STATE_JAMMU_AND_KASHMIR": [
      76.5762,
      33.7782
  ],
  "INDIAN_STATE_JHARKHAND": [
      85.2799,
      23.6102
  ],
  "INDIAN_STATE_KARNATAKA": [
      75.71389,
      15.317277
  ],
  "INDIAN_STATE_KERALA": [
      76.27108,
      10.850516
  ],
  "INDIAN_STATE_LAKSHADWEEP": [
      72.6417,
      10.5667
  ],
  "INDIAN_STATE_MADHYA_PRADESH": [
      77.947998,
      22.473324
  ],
  "INDIAN_STATE_MAHARASHTRA": [
      75.300293,
      19.66328
  ],
  "INDIAN_STATE_MANIPUR": [
      93.9063,
      24.6637
  ],
  "INDIAN_STATE_MEGHALAYA": [
      91.3662,
      25.467
  ],
  "INDIAN_STATE_MIZORAM": [
      92.9376,
      23.1645
  ],
  "INDIAN_STATE_NAGALAND": [
      94.5624,
      26.1584
  ],
  "INDIAN_STATE_DELHI": [
      77.1025,
      28.7041
  ]
};

export const idStateMapping = {
  "JK": "INDIAN_STATE_JAMMU_AND_KASHMIR",
  "GJ": "INDIAN_STATE_GUJARAT",
  "TN": "INDIAN_STATE_TAMIL_NADU",
  "AN": "INDIAN_STATE_ANDAMAN_AND_NICOBAR_ISLAND",
  "AP": "INDIAN_STATE_ANDHRA_PRADESH",
  "DD": "INDIAN_STATE_DAMAN_AND_DIU",
  "BR": "INDIAN_STATE_BIHAR",
  "LD": "INDIAN_STATE_LAKSHADWEEP",
  "MP": "INDIAN_STATE_MADHYA_PRADESH",
  "KA": "INDIAN_STATE_KARNATAKA",
  "PY": "INDIAN_STATE_PUDUCHERRY",
  "UP": "INDIAN_STATE_UTTAR_PRADESH",
  "WB": "INDIAN_STATE_WEST_BENGAL",
  "OR": "INDIAN_STATE_ODISHA",
  "CH": "INDIAN_STATE_CHANDIGARH",
  "HR": "INDIAN_STATE_HARYANA",
  "HP": "INDIAN_STATE_HIMACHAL_PRADESH",
  "AR": "INDIAN_STATE_ARUNACHAL_PRADESH",
  "NL": "INDIAN_STATE_NAGALAND",
  "KL": "INDIAN_STATE_KERALA",
  "PB": "INDIAN_STATE_PUNJAB",
  "AS": "INDIAN_STATE_ASSAM",
  "TR": "INDIAN_STATE_TRIPURA",
  "DN": "INDIAN_STATE_DADARA_AND_NAGAR_HAVELLI",
  "GA": "INDIAN_STATE_GOA",
  "LA": "INDIAN_STATE_JAMMU_AND_KASHMIR",
  "CT": "INDIAN_STATE_CHHATTISGARH",
  "MH": "INDIAN_STATE_MAHARASHTRA",
  "MN": "INDIAN_STATE_MANIPUR",
  "ML": "INDIAN_STATE_MEGHALAYA",
  "MZ": "INDIAN_STATE_MIZORAM",
  "RJ": "INDIAN_STATE_RAJASTHAN",
  "SK": "INDIAN_STATE_SIKKIM",
  "UT": "INDIAN_STATE_UTTARAKHAND",
  "JH": "INDIAN_STATE_JHARKHAND",
  "DL": "INDIAN_STATE_DELHI",
  "TG": "INDIAN_STATE_TELANGANA"
}

export function getStateIdFromValue(value) {
  return Object.keys(idStateMapping).find(key => idStateMapping[key] === value) || null;
}

export function getStateNameFromEnum(enumString) {
  if (!enumString.startsWith("INDIAN_STATE_")) return null;
  
  // Remove the prefix and format properly
  return enumString
    .replace("INDIAN_STATE_", "") // Remove prefix
    .replace(/_/g, " ") // Replace underscores with spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
}

